'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelDetailContentComponent = exports.parcelDetailContentComponent = {
    template: require('./parcel-detail-content.html'),
    bindings: {
        parcel: '<',
        confirmation: '<',
        cancel: '&?',
        canCancel: '<?'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;

        vm.onCancel = onCancel;

        function onCancel(lineId) {
            return vm.cancel(lineId);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/components/parcel-detail-content.js
// module id = 875
// module chunks = 0